/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { importCsv } from '../fn/sync/import-csv';
import { ImportCsv$Params } from '../fn/sync/import-csv';
import { KmlInfo } from '../models/kml-info';
import { Rider } from '../models/rider';
import { synchronizeCoordinates } from '../fn/sync/synchronize-coordinates';
import { SynchronizeCoordinates$Params } from '../fn/sync/synchronize-coordinates';
import { synchronizeRiders } from '../fn/sync/synchronize-riders';
import { SynchronizeRiders$Params } from '../fn/sync/synchronize-riders';

@Injectable({ providedIn: 'root' })
export class SyncService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `synchronizeRiders()` */
  static readonly SynchronizeRidersPath = '/races/{raceGuid}/syncriders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `synchronizeRiders()` instead.
   *
   * This method doesn't expect any request body.
   */
  synchronizeRiders$Response(params: SynchronizeRiders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Rider>>> {
    const obs = synchronizeRiders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `synchronizeRiders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  synchronizeRiders(params: SynchronizeRiders$Params, context?: HttpContext): Observable<Array<Rider>> {
    const resp = this.synchronizeRiders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Rider>>): Array<Rider> => r.body)
    );
  }

  /** Path part for operation `importCsv()` */
  static readonly ImportCsvPath = '/import-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importCsv$Response(params?: ImportCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = importCsv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importCsv(params?: ImportCsv$Params, context?: HttpContext): Observable<void> {
    const resp = this.importCsv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `synchronizeCoordinates()` */
  static readonly SynchronizeCoordinatesPath = '/classes/{raceClassGuid}/synchCoordinates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `synchronizeCoordinates()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  synchronizeCoordinates$Response(params: SynchronizeCoordinates$Params, context?: HttpContext): Observable<StrictHttpResponse<KmlInfo>> {
    const obs = synchronizeCoordinates(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `synchronizeCoordinates$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  synchronizeCoordinates(params: SynchronizeCoordinates$Params, context?: HttpContext): Observable<KmlInfo> {
    const resp = this.synchronizeCoordinates$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<KmlInfo>): KmlInfo => r.body)
    );
  }

}
